import SessionService from '@maestro/commerce-blocks/session/sessionService'

export default class LocalSessionService implements SessionService {
  private lastSearches: string[]
  private maxSearches: number

  constructor(maxSearches = 5) {
    this.lastSearches = []
    this.maxSearches = maxSearches
    this.loadSearchesFromLocalStorage()
  }

  public getLastSearches(): string[] {
    return this.lastSearches
  }

  public addSearch(searchTerm: string): void {
    const updatedSearches = [searchTerm, ...this.lastSearches].slice(
      0,
      this.maxSearches
    )
    this.lastSearches = updatedSearches
    this.saveSearchesToLocalStorage()
  }

  public removeSearch(index: number): void {
    this.lastSearches.splice(index, 1)
    this.saveSearchesToLocalStorage()
  }

  private saveSearchesToLocalStorage(): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('lastSearches', JSON.stringify(this.lastSearches))
    }
  }

  private loadSearchesFromLocalStorage(): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      const searches = JSON.parse(localStorage.getItem('lastSearches') || '[]')
      this.lastSearches = searches
    }
  }
}
